import axios from "axios";
import API_ENDPOINT from "../config";

export const login = async (email, password) => {
  let fd = new FormData();
  fd.append("email", email);
  fd.append("password", password);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}authentication/loginAdmin`,
    data: fd,
  });
  return res;
};

export const instituteRegistration = async (
  token,
  instituteName,
  username,
  email,
  password,
  address,
  city,
  state,
  country,
  description,
  contact,
  credits
) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("fname", instituteName);
  fd.append("username", username);
  fd.append("email", email);
  fd.append("password", password);
  fd.append("password_confirm", password);
  fd.append("address", address);
  fd.append("city", city);
  fd.append("state", state);
  fd.append("country", country);
  fd.append("description", description);
  fd.append("contact", contact);
  fd.append("credits", 0);
  fd.append("premiumFlag", 1);
  fd.append("serviceCost", 10);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}certificate/create`,
    data: fd,
  });
  return res.data;
};

export const registerUser = async (
  token,
  firstName,
  lastName,
  phone,
  username,
  country,
  state,
  city,
  address,
  email,
  password
) => {
  let fd = new FormData();

  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("fname", firstName);
  fd.append("lname", lastName);
  fd.append("phone", phone);
  fd.append("username", username);
  fd.append("country", country);
  fd.append("state", state);
  fd.append("city", city);
  fd.append("address", address);
  fd.append("group_id", "[8]");
  fd.append("email", email);
  fd.append("password", password);

  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}AdminPanel/createUser`,
    data: fd,
  });
  return res.data;
};

export const fetchUserDataApi = async (token) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}authentication/fetchUserData`,
    data: fd,
  });
  return res;
};
export const getUserDataApi = async (token, clientId) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("profileId", clientId);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}profile/getUserProfileData`,
    data: fd,
  });
  return res;
};

export const getUserGroups = async (token) => {
  let fd = new FormData();

  fd.append("token", JSON.stringify(token));

  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}AdminPanel/getGroups`,
    data: fd,
  });

  return res;
};
